import React from 'react';

import { useSelector } from 'react-redux';
import LazyLoad from 'react-lazyload';
import { isDesktop as isDesktopSelector } from '../../../store/modules/header-module';
type Props = {
  items: {
    src: string;
    url: string;
    alt: string;
    height: number;
  }[];
  className?: string;
};

const Logos = ({ items, className }: Props) => {
  const isDesktop = useSelector(isDesktopSelector);
  return (
    <div className={`${className || ''} d-sm-flex align-items-sm-center`} data-user1st-id="footer-logos">
      {items.map((logo) => (
        <LazyLoad key={logo.src} once>
          <a href={logo.url} target="_blank" rel="noopener noreferrer">
            <img
              src={logo.src}
              alt={logo.alt}
              className="mr-sm-12 mr-lg-24"
              style={{
                height: isDesktop ? logo.height : 36,
              }}
            />
          </a>
        </LazyLoad>
      ))}
    </div>
  );
};

export default Logos;
